import { Text } from '@/components/atoms/text';
import {
  DimensionHighlightContainer,
  DimensionHighlightContent,
  StyledDimensionHighlightContentText,
} from './styles';
import { Flex } from '@/styles/globalStyles';
import { OpportunityAndRiskCard } from '../cards/opportunityAndRisk';
import { useTranslation } from '@/hooks/useTranslation';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';

interface DimensionHighlightProps {
  opportunity: {
    name: string;
    value: string;
  }[];
  risk: {
    name: string;
    value: string;
  }[];
}

export const DimensionHighlight = ({ opportunity, risk }: DimensionHighlightProps) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { t } = useTranslation();

  const allDimensions = new Set([
    ...opportunity.map((item) => item.name),
    ...risk.map((item) => item.name),
  ]);

  const opportunityMap = new Map(opportunity.map((item) => [item.name, item.value]));
  const riskMap = new Map(risk.map((item) => [item.name, item.value]));

  const hasOpportunityData = opportunity && opportunity.length > 0;
  const hasRiskData = risk && risk.length > 0;

  return (
    <DimensionHighlightContainer variant={isMobile ? 'elevation' : 'outlined'} elevation={0}>
      <Text variant="h6">
        <SafeMarkdown text={t('label.label.dimension_highlight')} />
      </Text>

      <Flex justify="space-between" align="stretch" gap={3} fullWidth>
        <OpportunityAndRiskCard variant="opportunity" empty={!hasOpportunityData} isOverhallTab>
          {Array.from(allDimensions).map((dimensionName, index) => {
            if (!opportunityMap.get(dimensionName)) return null;

            return (
              <DimensionHighlightContent key={index}>
                <StyledDimensionHighlightContentText>
                  <Text variant="body2">{dimensionName}</Text>
                </StyledDimensionHighlightContentText>

                <Text variant="subtitle2">
                  <SafeMarkdown text={opportunityMap.get(dimensionName) || ''} />
                </Text>
              </DimensionHighlightContent>
            );
          })}
        </OpportunityAndRiskCard>

        <OpportunityAndRiskCard variant="risk" empty={!hasRiskData} isOverhallTab>
          {Array.from(allDimensions).map((dimensionName, index) => {
            if (!riskMap.get(dimensionName)) return null;

            return (
              <DimensionHighlightContent key={index}>
                <StyledDimensionHighlightContentText>
                  <Text variant="body2">{dimensionName}</Text>
                </StyledDimensionHighlightContentText>

                <Text variant="subtitle2">
                  <SafeMarkdown text={riskMap.get(dimensionName) || ''} />
                </Text>
              </DimensionHighlightContent>
            );
          })}
        </OpportunityAndRiskCard>
      </Flex>
    </DimensionHighlightContainer>
  );
};
